import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import { mapActions } from "vuex";
import store from "@/store";

const {
  FLUXO_CHECKIN,
  LISTAR_CHECKIN,
  DESFAZER_QUEIMA_INGRESSO,
  VALIDATE_TICKET,
  EXPORTAR_CHECKIN,
} = ENDPOINTS;

const { $axios } = Vue.prototype;
const { post } = $axios;

Vue.prototype.$checkin = new Vue({
  data() {
    return {
      ENDPOINTS,
      produto_selecionado: "",
      modalSelectStore: false,
      produtos_loading: false,
      lojas_loading: false,
      searchValue: "",
      produtos: [],
      loading_table: false,
      itemsCheckin: [],
      itemsFlow: [],
    };
  },
  methods: {
    ...mapActions(["fetchEvents"]),
    getItemsToCheckIn(filter) {
      this.loading_table = true;
      let data = {
        loja: store.getters.storeSequencial,
        idproduto: this.produto_selecionado,
        documento: filter,
      };
      post(LISTAR_CHECKIN, data).then(res => {
        this.loading_table = false;
        this.itemsCheckin = res;
      });
    },
    getCheckInFlow() {
      this.loading_table = true;
      let data = {
        loja: store.getters.storeSequencial,
        idproduto: this.produto_selecionado,
      };
      post(FLUXO_CHECKIN, data).then(res => {
        this.loading_table = false;
        this.itemsFlow = res;
      });
    },
    exportCheckIn(filter, type) {
      let data = {
        loja: store.getters.storeSequencial,
        idproduto: this.produto_selecionado,
        documento: filter,
        exportation: type,
      };
      const typeExport = type === "CSV" ? "text/csv" : "application/pdf";

      this.$axios.postPDF(EXPORTAR_CHECKIN, JSON.stringify(data)).then(res => {
        try {
          const file = new Blob([res], { type: typeExport });
          const fileURL = URL.createObjectURL(file);

          if (type === "CSV") {
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = fileURL;
            a.download = `CheckIn.csv`;
            a.click();
            window.URL.revokeObjectURL(fileURL);
          } else {
            window.open(fileURL);
          }
        } catch (error) {
          console.error(`Erro ao exportar dados: ${error.message}`);
        }
      });
    },
    undoBurnTicket(item) {
      this.loading_table = true;
      let data = {
        loja: store.getters.storeSequencial,
        iditem: item.iditem,
      };
      post(DESFAZER_QUEIMA_INGRESSO, data).then(() => {
        this.getItemsToCheckIn();
        this.getCheckInFlow();
      });
    },
    burnTicket(item) {
      this.loading_table = true;
      let data = {
        idconsumidor: item.idconsumidor,
        loja: store.getters.storeSequencial,
        midia: item.midia,
      };
      post(VALIDATE_TICKET, data).then(() => {
        this.getItemsToCheckIn();
        this.getCheckInFlow();
      });
    },
    filterByAnyThing(searchValue) {
      this.searchValue = searchValue;
      this.getItemsToCheckIn(searchValue);
    },
  },
});
